var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":this.snackbar.show,"multi-line":true},on:{"input":_vm.hideSnackbar},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"color":"red","text":""},on:{"click":_vm.hideSnackbar}},'v-btn',attrs,false),[_vm._v(" Close ")])]}}])},[_vm._v(" "+_vm._s(this.snackbar.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }